import { patientActions, noteActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { PCCCategoryIds } from '_constants'
import { log } from '_services'

const initialState = {
};


export const reducer = createReducer(initialState, {

    [patientActions.loadSuccess]: (state, action) => {
        var patients = {};

        Object.values(action.payload.entities.patients).forEach(x => {
            patients[x.id] = {
                id: x.id,
                selectedHomeCategory: PCCCategoryIds.ADMISSIONS,
                selectedTab: 'HOME_' + x.id
            };
        });
        state = { ...state, ...patients };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        return { ...state, ...action.payload.ui.patientCenter };
    },
    [patientActions.closeSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [patientActions.categoryChange]: (state, action) => {
        state[action.payload.ptno].selectedHomeCategory = action.payload.selectedHomeCategory;
    },
    [patientActions.openPdfRequest]: (state, action) => {
        if (state[action.payload.ptno] && action.payload.openTab) {
            state[action.payload.ptno].selectedTab = 'PDF_' + action.payload.noteId;
        }
    },
    [patientActions.loadPdfFailure]: (state, action) => {
        log.error('Error loading PDF.  noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [patientActions.closeTab]: (state, action) => {
        state[action.payload.ptno].selectedTab = 'HOME_' + action.payload.ptno;
    },
    [patientActions.setTabActiveSuccess]: (state, action) => {
        state[action.payload.ptno].selectedTab = action.payload.selectedTab;
    },
    [patientActions.openAlRequest]: (state, action) => {
        if (state[action.payload.ptno] && action.payload.openTab) {
            state[action.payload.ptno].selectedTab = 'AL_' + action.payload.epno;
        }
    },
    [patientActions.openAlFailure]: (state, action) => {
        log.error('Error loading AL.  epno: ' + action.payload.epno + ' error: ' + action.payload.error);
    },
    [noteActions.openInProgNoteRequest]: (state, action) => {
        state[action.payload.ptno].selectedTab = 'IN_' + action.payload.noteId;
    },
    [noteActions.startBlankEvalSuccess]: (state, action) => {
        state[action.payload.ptno].selectedTab = 'IN_' + action.payload.noteId;
    },
    [noteActions.transferEvalSuccess]: (state, action) => {
        //state[action.payload.ptno].selectedTab = 'IN_' + action.payload.noteId;
        
    },
    [noteActions.prepopulateEvalSuccess]: (state, action) => {
        state[action.payload.ptno].selectedTab = 'IN_' + action.payload.noteId;
    },
})


